import { useEffect, useCallback } from 'react';

/**
 * Hook to listen for auth refresh events and trigger a callback
 * This helps components reload their data after session refresh
 */
export const useAuthRefresh = (callback: () => void | Promise<void>) => {
  const handleAuthRefresh = useCallback(() => {
    console.log('Auth refresh event detected, reloading data...');
    callback();
  }, [callback]);

  useEffect(() => {
    // Listen for auth refresh events
    window.addEventListener('auth-refresh', handleAuthRefresh);
    
    return () => {
      window.removeEventListener('auth-refresh', handleAuthRefresh);
    };
  }, [handleAuthRefresh]);
};
